import { JourneyTrack } from '../journey-track';
import { TrackTypes } from '../model/track-types';
import { TrackInfo } from '../model/track-info';
import { TrackActionResult } from '../model/track-action-result';
import { MaritalStatusInvestActionV2 } from './actions/marital-status-v2-action';
import { OriginIncomeInvestActionV2 } from './actions/origin-income-v2-action';
import { OriginInvestActionV2 } from './actions/origin-v2-action';
import { BirthCountryInvestActionV2 } from './actions/birth-country-v2-action';
import { trackDefaultIncomeBasicV2 } from './util/track-default-income-v2';
import { UserRegistrationFactoryService } from '../../../user-registration/user-registration-factory-service';
import { DataOrigin } from '../../../../model/DataOrigin';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';
import { UserRegistrationParseData } from './util/user-registration-parse-data';
import { NavController } from '@ionic/angular';

export class BasicTrackV2 extends JourneyTrack {
  readonly originalTracks = [
    new TrackInfo('minor', ['minor']),
    new TrackInfo("overview-user-not-editable", ["overview-validated","overview-user-not-editable"]),
    new TrackInfo('overview-error', ['overview-error', 'overview-error']),
    new TrackInfo('overview-status', ['overview-status', 'overview-user']),

    new TrackInfo('page-name', ['profile', 'name']),
    new TrackInfo('page-email', ['profile', 'email']),
    new TrackInfo('page-phone', ['profile', 'phone']),

    new TrackInfo('document-type', ['personal-data', 'document-type']),
    new TrackInfo('document-name', ['personal-data', 'document-name']),
    new TrackInfo('document-number', ['personal-data', 'document-number']),
    new TrackInfo('document-issuing', ['personal-data', 'document-issuing']),
    new TrackInfo('expedition-state', ['personal-data', 'expedition-state']),
    new TrackInfo('parentage', ['personal-data', 'parentage']),
    new TrackInfo('date-birth', ['personal-data', 'date-birth']),
    new TrackInfo('birth-country', ['personal-data', 'birth-country'], undefined, {
      undefined,
      actionName: ActionList.ActionStateBR
    }),
    new TrackInfo('birth-state', ['personal-data', 'birth-state']),
    new TrackInfo('birth-city', ['personal-data', 'birth-city']),
    new TrackInfo('nationality', ['personal-data', 'nationality']),
    new TrackInfo('gender', ['personal-data', 'gender']),

    new TrackInfo('marital-status', ['marital-status', 'marital-status'], undefined, {
      undefined,
      actionName: ActionList.ActionMarital
    }),
    new TrackInfo('spouse', ['marital-status', 'spouse']),

    new TrackInfo('cep', ['address', 'cep']),
    new TrackInfo('address-completed', ['address', 'completed']),

    new TrackInfo('origin-income', ['professional-data', 'origin-income'], undefined, {
      undefined,
      actionName: ActionList.ActionOrigin
    }),
    new TrackInfo('profession', ['professional-data', 'profession'], undefined, {
      undefined,
      actionName: ActionList.ActionIncome
    }),
    new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj']),

    ...trackDefaultIncomeBasicV2,
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),
    new TrackInfo('rlp', ['rlp'])

  ];

  track = [];
  public registratioJourney: any;
  dataOrigin = DataOrigin.Mobile;

  constructor(
    private userRegistrationFactoryService: UserRegistrationFactoryService,
    private router: NavController,
  ) {
    super();
  }

  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC_V2;
  }

  async loadData() {
    const data = await this.userRegistrationFactoryService.getService(this.dataOrigin).getUserRegistration();
    const newData = UserRegistrationParseData.formatToRegistrationJourney(data, this.getName());
    this.registratioJourney = newData;
    this.setBasicTrack();
    localStorage.setItem('cache-native', JSON.stringify(newData));
    return Promise.resolve(newData);
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    switch (actionName) {
      case ActionList.ActionStateBR:
        return BirthCountryInvestActionV2.execute(data);
      case ActionList.ActionMarital:
        return MaritalStatusInvestActionV2.execute(data, this.track);
      case ActionList.ActionOrigin:
        return OriginInvestActionV2.execute(data, this.track, false);
      case ActionList.ActionIncome:
        return OriginIncomeInvestActionV2.execute(data);
    }
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }

  public async setBasicTrack() {
    const trackCI: string[] = [];
    // validação e redirecionamento para tela de menor de idade
    if (this.registratioJourney.data?.personalData?.age < 18) {
      trackCI.push('minor');
    }
    // validação tela de dados não editáveis
    if (this.registratioJourney.data?.situacao?.redireciona_app_itau) {
      trackCI.push('overview-validated');
    }
    trackCI.push('overview-status');
    trackCI.push('data');
    trackCI.push('broker');
    trackCI.push('terms');
    // toggle inclusão tela de custódia/rlp
    if (JSON.parse(localStorage.getItem('getToggle')) === true || JSON.parse(localStorage.getItem('getToggle')) === "true") {
      trackCI.push('rlp');
    }
   
    if (this.registratioJourney.data?.errorData?.code !== undefined ||
      this.registratioJourney.data?.errorData?.data?.statuscode !== undefined ||
      this.registratioJourney.data?.personalData === undefined && this.registratioJourney.data?.address === undefined
      && this.registratioJourney.data?.maritalStatus === undefined && this.registratioJourney.data?.professionalData === undefined
      && this.registratioJourney.data?.incomeEquity === undefined) {
      trackCI.push('overview-error');
    }

    if (!this.profileCompleted()) {
      trackCI.push('profile');
    }

    if (!this.registratioJourney.data?.personalData?.isCompleted) {
      trackCI.push('personal-data');
    }

    if (!this.registratioJourney.data?.address?.isCompleted) {
      trackCI.push('address');
    }

    if (!this.registratioJourney.data?.maritalStatus?.isCompleted) {
      trackCI.push('marital-status');
    }

    if (!this.registratioJourney.data?.professionalData?.isCompleted) {
      trackCI.push('professional-data');
    }

    if (!this.registratioJourney.data?.incomeEquity?.isCompleted) {
      trackCI.push('income');
    }

    if (trackCI.length > 0) {
      this.track = this.originalTracks.filter((trackInfo: TrackInfo) => trackCI.includes(trackInfo.path[0]));
    } else {
      this.track = this.originalTracks;
    }
  }

  profileCompleted(): boolean {
    if (this.registratioJourney.data?.profileData?.name !== undefined &&
      this.registratioJourney.data?.profileData?.name !== '' &&
      this.registratioJourney.data?.profileData?.email !== undefined &&
      this.registratioJourney.data?.profileData?.email !== '' &&
      this.registratioJourney.data?.profileData?.phoneNumber !== undefined &&
      this.registratioJourney.data?.profileData?.phoneNumber !== '') {
      return true;
    } else {
      return false;
    }
  }
}

export enum ActionList {
  ActionState = 'actionState',
  ActionStateBR = 'actionStateBR',
  ActionOrigin = 'actionOrigin',
  ActionIncome = 'actionIncome',
  ActionMarital = 'actionMarital'
}
